import { Injectable } from '@angular/core';
import { TechnicalProductsOpenPlatformService, TechnicalProductsRequestOP } from '@cemex-core/cmx-api';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, filter, map, switchMap, take, withLatestFrom } from 'rxjs/operators';

import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { getOpenPlatformProducts } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/products.selectors';
import { getOpenPlatformCombinations } from '@ordersnproducts/modules/order-builder/modules/rms-specification/selectors/combinations.selectors';
import {
  AddedValueActionTypes,
  AddedValuesResetActionOP,
  LoadAddedValuesActionOP,
  LoadAddedValuesCompleteActionOP,
} from '@ordersnproducts/modules/order-builder/modules/rms-specification/actions/open-platform/added-values.actions';
import { makeReference } from '@ordersnproducts/utils/mix-reference';

@Injectable()
export class AddedValuesOpenPlatformEffects {
  loadAddedValues$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AddedValueActionTypes.LOAD_ADDED_VALUES_OP),
      switchMap((action: LoadAddedValuesActionOP) => {
        return this.store.select(getOpenPlatformProducts).pipe(
          take(1),
          filter(() => {
            if (!action.payload.addedValues) {
              // Enters here only when fetching first added values
              return true;
            } else {
              // If addedValues is defined, must contain trueable values
              // Can get undefined/null values when unselecting from combo box
              const valid = action.payload.addedValues.every((value) => !!value);
              if (!valid) {
                this.store.dispatch(
                  new LoadAddedValuesCompleteActionOP({
                    productCode: action.payload.productCode,
                    index: action.payload.index,
                    addedValues: null,
                    technicalProduct: null,
                    contractCode: null,
                    formId: null,
                  }),
                );
              }
              return valid;
            }
          }),
          map((productState) => productState.find((product) => makeReference(product) === action.payload.productCode)),
          withLatestFrom(this.store.pipe(select(getOpenPlatformCombinations))),
          switchMap(([selectedProduct, combinationsEntities]) => {
            let valueAddeds = [];
            if (action.payload.addedValues) {
              valueAddeds = valueAddeds.concat(action.payload.addedValues);
            }
            const aux: TechnicalProductsRequestOP = {
              product: selectedProduct,
              selectedValueAddeds: valueAddeds,
              combinations: combinationsEntities,
            };
            return !!selectedProduct && this.technicalProductsOpenPlatformApi.fetch(aux);
          }),
          map((response: any) => {
            response.technicalProducts.forEach;
            return new LoadAddedValuesCompleteActionOP({
              productCode: action.payload.productCode,
              index: action.payload.index,
              addedValues: response.valueAddeds,
              technicalProduct: response.technicalProducts,
              contractCode: action.payload.contractCode,
              formId: action.payload.formId,
            });
          }),
        );
      }),
      catchError((error) => {
        return of(new AddedValuesResetActionOP());
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private store: Store<OrderBuilderState>,
    private technicalProductsOpenPlatformApi: TechnicalProductsOpenPlatformService,
  ) {}
}
